import { get, post, put, del } from '@/api/request'

// ==================== 门户文章（新闻动态 / 服务场景） ====================

// 分页查询门户文章列表
// 参数：type（news=新闻动态 / scene=服务场景）、status（0=草稿 / 1=已发布）、pageNum、pageSize
export function getPortalArticlePage(params) {
  return get('/portal/admin/articles', params)
}

// 获取门户文章详情
export function getPortalArticleDetail(id) {
  return get(`/portal/admin/articles/${id}`)
}

// 创建门户文章
export function createPortalArticle(data) {
  return post('/portal/admin/articles', data)
}

// 更新门户文章
export function updatePortalArticle(id, data) {
  return put(`/portal/admin/articles/${id}`, data)
}

// 删除门户文章
export function deletePortalArticle(id) {
  return del(`/portal/admin/articles/${id}`)
}

// ==================== 门户 Banner ====================

// 分页查询门户Banner列表
export function getPortalBannerPage(params) {
  return get('/portal/admin/banners', params)
}

// 获取门户Banner详情
export function getPortalBannerDetail(id) {
  return get(`/portal/admin/banners/${id}`)
}

// 创建门户Banner
export function createPortalBanner(data) {
  return post('/portal/admin/banners', data)
}

// 更新门户Banner
export function updatePortalBanner(id, data) {
  return put(`/portal/admin/banners/${id}`, data)
}

// 删除门户Banner
export function deletePortalBanner(id) {
  return del(`/portal/admin/banners/${id}`)
}

// ==================== 门户 FAQ ====================

// 分页查询门户FAQ列表
export function getPortalFaqPage(params) {
  return get('/portal/admin/faqs', params)
}

// 获取门户FAQ详情
export function getPortalFaqDetail(id) {
  return get(`/portal/admin/faqs/${id}`)
}

// 创建门户FAQ
export function createPortalFaq(data) {
  return post('/portal/admin/faqs', data)
}

// 更新门户FAQ
export function updatePortalFaq(id, data) {
  return put(`/portal/admin/faqs/${id}`, data)
}

// 删除门户FAQ
export function deletePortalFaq(id) {
  return del(`/portal/admin/faqs/${id}`)
}
